import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';
import {rootActions, useAppDispatch, useAppSelector} from '../../data/store';

export const ThemeButtons = () => {

    const dispatch = useAppDispatch();
    const layoutMode = useAppSelector(store => store.layoutMode);
    const isGridSelected = layoutMode === 'grid';
    const isListSelected = layoutMode === 'list';

    /**
     * Apply layout.
     */
    const applyLayout = (selectedLayout: string) => {

        dispatch(
            rootActions.refreshAndStorageDeepLink({
                layoutMode: selectedLayout
            })
        );
    };

    return (
        <div className="flex items-center">
            {/* grid */}
            <button type="button" onClick={evt => {
                applyLayout('grid');
                sendGAEvent('JPList', 'Top Theme Grid');
            }}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <title>Grid View Button</title>
                    <path
                        d="M3.84 11.52h4.8V5.76h-4.8v5.76zm0 7.68h4.8v-5.76h-4.8v5.76zm5.76 0h4.8v-5.76H9.6v5.76zm5.76 0h4.8v-5.76h-4.8v5.76zM9.6 11.52h4.8V5.76H9.6v5.76zm5.76-5.76v5.76h4.8V5.76h-4.8z"
                        fill={ isGridSelected ? '#1d1d1d' : '#dbdbdb'}
                        fillRule="evenodd"  /></svg>
            </button>

            {/* list */}
            <button type="button" onClick={evt => {
                applyLayout('list');
                sendGAEvent('JPList', 'Top Theme List');
            }}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <title>List View Button</title>
                    <path
                        fill={ isListSelected ? '#1d1d1d' : '#dbdbdb'}
                        d="M3.84 14.4h3.84v-3.84H3.84v3.84zm0 4.8h3.84v-3.84H3.84v3.84zm0-9.6h3.84V5.76H3.84V9.6zm4.8 4.8h11.52v-3.84H8.64v3.84zm0 4.8h11.52v-3.84H8.64v3.84zm0-13.44V9.6h11.52V5.76H8.64z"/>
                </svg>
            </button>
        </div>
    )
};